<!--  ******************************************************  -->
<!--  ADD or UPDATE CUSTOMER DIALOG                           -->
<!--    - Allows the customerUser to insert or update a customer      -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex *ngIf="data.isNewCharger">
    {{'PRODUCTITEM.E015_CHARGER.ADD' | translate}}
  </h2>
  <h2 mat-dialog-title fxFlex *ngIf="!data.isNewCharger">
    {{'PRODUCTITEM.E015_CHARGER.UPDATE' | translate}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="mat-typography dialogBody">


  <form class="example-form" #putCharger="ngForm">

    <!--  ************************************  -->
    <!--       CHARGER PICKUP_POINT_ID          -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'PRODUCTITEM.E015_CHARGER.PICKUP_POINT' | translate}}</mat-label>
      <input matInput required #chargerPickUpPointId="ngModel" type="text" name="chargerPickUpPointId" [disabled]="!data.isNewCharger"
             [(ngModel)]="data.charger.energyPickupPointId">
      <mat-error *ngIf="chargerPickUpPointId.invalid">
        {{'PRODUCTITEM.E015_CHARGER.PICKUP_POINT_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
      </mat-error>
    </mat-form-field>


    <!--  ************************************  -->
    <!--             CHARGER TYPE               -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'PRODUCTITEM.E015_CHARGER.CONNECTOR_TYPE' | translate}}</mat-label>
      <input matInput required #chargerConnectorType="ngModel" type="text" name="chargerConnectorType" [(ngModel)]="data.charger.connectorType">
      <mat-error *ngIf="chargerConnectorType.invalid">
        {{'PRODUCTITEM.E015_CHARGER.CONNECTOR_TYPE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
      </mat-error>
    </mat-form-field>

    <!--  ************************************  -->
    <!--             CHARGER POWER               -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'PRODUCTITEM.E015_CHARGER.CONNECTOR_POWER' | translate}}</mat-label>
      <input matInput required #chargerConnectorPower="ngModel" type="number" name="chargerConnectorPower" [(ngModel)]="data.charger.connectorPower">
      <mat-error *ngIf="chargerConnectorPower.invalid">
        {{'PRODUCTITEM.E015_CHARGER.CONNECTOR_POWER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
      </mat-error>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="putCharger.invalid? true : false" (click)="insertProductItemCharger()">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
